__turbopack_context__.v({
  "address": "BrowserFrame-module__mtON1W__address",
  "addressEdit": "BrowserFrame-module__mtON1W__addressEdit",
  "addressInput": "BrowserFrame-module__mtON1W__addressInput",
  "addressText": "BrowserFrame-module__mtON1W__addressText",
  "bar": "BrowserFrame-module__mtON1W__bar",
  "content": "BrowserFrame-module__mtON1W__content",
  "dots": "BrowserFrame-module__mtON1W__dots",
  "favicon": "BrowserFrame-module__mtON1W__favicon",
  "frame": "BrowserFrame-module__mtON1W__frame",
});
